// extracted by mini-css-extract-plugin
export default {"container":"eM-z","topReviewHeading":"fM-z","criticalReview":"gM-z","favorableReview":"hM-z","vsSeparator":"iM-z"};